
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
    square: String,
    value: String,
    isGameSquare: Boolean,
    isSelected: Boolean,
    isPeer: Boolean,
    isSameValue: Boolean,
    isIncorrect: Boolean,
    notes: Object
  },
  emits: ['click-square']
})
export default class Square extends Vue {
  value!: string;
}
